import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    doctorsWrapper: {
        marginTop: '50px',
    },
}));

export { useStyles };